import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Input = React.forwardRef(function Input2({ className, type, onWheel, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      type,
      ref,
      onWheel: (event) => {
        if (type === "number" && document.activeElement === event.currentTarget) {
          event.currentTarget.blur();
        }
        onWheel?.(event);
      },
      className: cn(
        "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 focus-ring",
        className
      ),
      ...props
    }
  );
});

export { Input };
//# sourceMappingURL=chunk-NHXI3UAE.js.map
//# sourceMappingURL=chunk-NHXI3UAE.js.map